import BigNumber from 'bignumber.js';

import type { LiquidityHubSnapshot } from 'types';

import type { GetLiquidityHubHistoryResponse } from '..';
import { getApiLiquidityHubSnapshotArray } from '../getApiLiquidityHubSnapshotArray';

export const formatApiLiquidityHubHistory = (
  payload: GetLiquidityHubHistoryResponse,
): LiquidityHubSnapshot[] =>
  getApiLiquidityHubSnapshotArray(payload).map(snapshot => ({
    blockNumber: snapshot.blockNumber,
    blockTimestamp: snapshot.blockTimestamp,
    supplyApy: new BigNumber(snapshot.supplyApy).toFixed(),
    totalSupplyCents: new BigNumber(snapshot.totalSupplyCents ?? 0).toFixed(),
    pricePerShare: new BigNumber(snapshot.pricePerShare).toFixed(),
  }));
